import type { PropsWithChildren } from 'react';
import { cn } from '../../lib/utils.ts';

type Props = {
    className?: string;
} & PropsWithChildren;

export const DataText: React.FC<Props> = ({ children, className = '' }) => {
    return <span className={cn('tabular-nums', className)}>{children}</span>;
};
